import React from 'react';
import { Link } from 'react-router-dom';
import IFormatterEntry from 'common/types/IFormatterEntry';

const WorkerDetailLink = ({ entry }: IFormatterEntry) => (
  <Link to={`/workers/${entry}`} className='worker-detail-link'>View</Link>
);

export default WorkerDetailLink;
